module.exports = __webpack_public_path__ + "modal.jpg?18350fa6dedd8e6aeaad9882a6b06f6f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calendar-info/modal.jpg
// module id = 492
// module chunks = 1